/**
 * wa-chat-bg — Patrón de fondo estilo WhatsApp para el área de mensajes.
 *
 * Replica el wallpaper de WhatsApp: íconos outline densos y ordenados en grid,
 * casi juntos, sobre fondo beige claro (#ECE5DD). Los íconos son stroke-only
 * y cubren toda la superficie sin huecos visibles.
 */

const ICONS: string[] = [
  // 0: Burbuja chat con líneas
  '<rect x="1" y="1" width="14" height="10" rx="1.5" fill="none"/><line x1="3.5" y1="4" x2="12" y2="4"/><line x1="3.5" y1="7" x2="9" y2="7"/><path d="M4 11v2.5l2.5-2.5" fill="none"/>',
  // 1: Burbuja con puntos (escribiendo)
  '<rect x="1" y="2" width="14" height="10" rx="1.5" fill="none"/><circle cx="5" cy="7" r=".8"/><circle cx="8" cy="7" r=".8"/><circle cx="11" cy="7" r=".8"/><path d="M4 12v2l2-2" fill="none"/>',
  // 2: Doble burbuja
  '<rect x="0" y="1" width="10" height="7" rx="1.5" fill="none"/><path d="M3 8v2l2-2" fill="none"/><rect x="6" y="4" width="10" height="7" rx="1.5" fill="none"/><path d="M13 11v2l-2-2" fill="none"/>',
  // 3: Laptop con chat
  '<rect x="2" y="1" width="12" height="8" rx="1" fill="none"/><path d="M0 9h16v1.5c0 .8-.7 1.5-1.5 1.5H1.5C.7 12 0 11.3 0 10.5z" fill="none"/><line x1="5" y1="4" x2="11" y2="4"/><line x1="5" y1="6" x2="9" y2="6"/>',
  // 4: Persona + burbuja
  '<circle cx="5" cy="4" r="2.5" fill="none"/><path d="M0 13c0-2.8 2.2-5 5-5s5 2.2 5 5" fill="none"/><rect x="10" y="1" width="6" height="4.5" rx="1" fill="none"/><line x1="11.5" y1="3" x2="14.5" y2="3"/>',
  // 5: Dos personas
  '<circle cx="4.5" cy="4.5" r="2" fill="none"/><circle cx="11.5" cy="4.5" r="2" fill="none"/><path d="M0 13c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5" fill="none"/><path d="M9 13c0-2.5 1.5-4 3.5-4" fill="none"/>',
  // 6: Burbuja con emoji
  '<rect x="1" y="1" width="14" height="11" rx="2" fill="none"/><circle cx="5.5" cy="5.5" r=".9" fill="none"/><circle cx="10.5" cy="5.5" r=".9" fill="none"/><path d="M5 8.5c1 1.5 5 1.5 6 0" fill="none"/><path d="M4 12v2.5l2.5-2.5" fill="none"/>',
  // 7: Imagen (montaña)
  '<rect x="1" y="1" width="14" height="11" rx="1.5" fill="none"/><circle cx="5" cy="4.5" r="1.5" fill="none"/><path d="M1 10l3.5-3.5 2.5 2.5 3-3L15 10" fill="none"/>',
  // 8: Play (video)
  '<circle cx="8" cy="7.5" r="6.5" fill="none"/><path d="M6 4.5l5.5 3-5.5 3z" fill="none"/>',
  // 9: Enviar (flecha)
  '<circle cx="8" cy="7.5" r="6.5" fill="none"/><path d="M4.5 7.5h7M9 4.5l3 3-3 3" fill="none"/>',
  // 10: Monitor
  '<rect x="1" y="1" width="14" height="9" rx="1" fill="none"/><line x1="5.5" y1="10" x2="5.5" y2="13"/><line x1="10.5" y1="10" x2="10.5" y2="13"/><line x1="3" y1="13" x2="13" y2="13"/><line x1="4" y1="4.5" x2="12" y2="4.5"/><line x1="4" y1="7" x2="9" y2="7"/>',
  // 11: Estrella
  '<path d="M8 0l2.2 4.5 5 .7-3.6 3.5.8 5L8 11.5 3.6 13.7l.8-5L.8 5.2l5-.7z" fill="none"/>',
  // 12: Triángulo
  '<path d="M8 1L15 14H1z" fill="none"/>',
  // 13: Cuadrado con punto
  '<rect x="2" y="2" width="12" height="12" rx=".5" fill="none"/><circle cx="8" cy="8" r="1.5" fill="none"/>',
  // 14: Burbuja simple
  '<path d="M3 2c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h1v3l3-3h6c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" fill="none"/>',
  // 15: Documento
  '<path d="M4 1h6l4 4v9c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1V2c0-.6.4-1 1-1z" fill="none"/><path d="M10 1v4h4" fill="none"/><line x1="5" y1="8" x2="11" y2="8"/><line x1="5" y1="10.5" x2="9" y2="10.5"/>',
  // 16: Corazón en burbuja
  '<rect x="1" y="1" width="14" height="10" rx="2" fill="none"/><path d="M8 9l-2.8-2.5C4 5.5 4 4 5.5 3.5c.8-.3 1.7.1 2.5.8.8-.7 1.7-1.1 2.5-.8C12 4 12 5.5 10.8 6.5z" fill="none"/><path d="M4 11v2l2-2" fill="none"/>',
  // 17: Cámara video
  '<rect x="1" y="3" width="10" height="8" rx="1.5" fill="none"/><path d="M11 5.5l4-2.5v8l-4-2.5z" fill="none"/>',
  // 18: Diamante
  '<path d="M8 1l7 7-7 7-7-7z" fill="none"/>',
  // 19: Micrófono
  '<rect x="5" y="1" width="5" height="7" rx="2.5" fill="none"/><path d="M3 7c0 2.8 2.2 5 5 5s5-2.2 5-5" fill="none"/><line x1="7.5" y1="12" x2="7.5" y2="15"/><line x1="5" y1="15" x2="10" y2="15"/>',
];

// Grid denso: celdas de ~36×36 en tile 360×360 = 10 columnas × 10 filas = 100 placements
// Offset alterno para romper la cuadrícula perfecta (como WhatsApp)
const TILE = 280;
const COLS = 10;
const ROWS = 10;
const CELL = TILE / COLS; // 28px

const P: Array<[number, number, number, number]> = [];
for (let row = 0; row < ROWS; row++) {
  for (let col = 0; col < COLS; col++) {
    const xOff = row % 2 === 0 ? 0 : CELL * 0.5; // offset alterno
    const x = col * CELL + xOff + 2;
    const y = row * CELL + 2;
    // Rotación sutil pseudo-aleatoria basada en posición
    const rot = ((col * 7 + row * 13) % 25) - 12;
    const scale = 1.15 + ((col + row) % 3) * 0.05; // 1.15 - 1.25
    P.push([x, y, rot, scale]);
  }
}

function buildSvgPattern(): string {
  let content = '';
  P.forEach(([x, y, rot, scale], i) => {
    const icon = ICONS[i % ICONS.length];
    content += `<g transform="translate(${x},${y}) rotate(${rot}) scale(${scale})" stroke="#8696a0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" opacity="0.12" fill="none">${icon}</g>`;
  });

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${TILE}" height="${TILE}" fill="none">${content}</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

/** URL del SVG pattern */
export const WA_CHAT_BG_URL = buildSvgPattern();

/** Color de fondo base estilo WhatsApp (light mode) */
export const WA_CHAT_BG_COLOR = '#ECE5DD';

/**
 * Estilos para el contenedor del thread de mensajes.
 */
export const waChatBgStyle: React.CSSProperties = {
  backgroundColor: WA_CHAT_BG_COLOR,
  backgroundImage: `url("${WA_CHAT_BG_URL}")`,
  backgroundRepeat: 'repeat',
  backgroundSize: `${TILE}px ${TILE}px`,
};
